import { gql } from '@apollo/client';

export const COMMISSION_CALCULATION_METHODS_QUERY = gql`
  query commissionCalculationMethods($pager: PagerInputNew, $filters: CommissionCalculationMethodsFilterInput) {
    commissionCalculationMethods(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        code
        typeId
        typeName
        percentIsMandatory
        assetIsMandatory
        ppIsMandatory
        percentFormula
        amountFormula
      }
    }
  }
`;

export const COMMISSION_CALCULATION_METHOD_TYPES_QUERY = gql`
  query commissionCalculationMethodTypes {
    commissionCalculationMethodTypes {
      id
      code
      name
    }
  }
`;

export const ALLOWED_FORMULA_VARIABLES_QUERY = gql`
  query allowedFormulaVariables {
    allowedFormulaVariables {
      name
      description
    }
  }
`;

export const COMMISSION_CALCULATION_METHOD_LIST_FILTERS_QUERY = gql`
  {
    commissionCalculationMethodsListFilters @client {
      fullTextFilter {
        value
      }
      typeId {
        value
      }
    }
  }
`;
